import { FormShareLink, FormShareSourcesResponse } from '../types';
import {
  FormShareLinkApiItem,
  FormShareLinksApiResponse
} from '../types/formShareLinksApi';

export const mapFormShareLinkApiItem = (
  item: FormShareLinkApiItem
): FormShareLink => ({
  id: item.id,
  label: item.label,
  formLink: item.form_link,
  iconUrl: item.icon_url || undefined
});

export const mapFormShareLinksApi = (
  items: FormShareLinkApiItem[] | null | undefined
): FormShareLink[] => (items ?? []).map(mapFormShareLinkApiItem);

export const mapFormShareSourcesApi = (
  response: FormShareLinksApiResponse
): FormShareSourcesResponse => ({
  enable: response.enable,
  sources: mapFormShareLinksApi(response.data ?? [])
});
